import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'app-formly-group-wrapper',
  template: `
    <h3 class="meta-subheader half-margin-bottom">{{ props.label }}</h3>
    <ng-container #fieldComponent></ng-container>
  `,
})
export class GroupWrapperComponent extends FieldWrapper {}
